import React from 'react'
import PropTypes from 'prop-types'

const StepWizard = props => {
  const noop = () => {}
  const activeStep = props.activeStep || 0
  const onStepChanged = props.onStepChanged || noop
  const steps = [...Array(props.numberOfSteps).keys()]
  const lastStep = props.numberOfSteps - 1

  return (
    <div className="StepWizard text-center my-5">
      {steps.map(step => {
        let className = 'bg-white border-secondary text-muted'
        let separatorClassName = 'bg-secondary'

        if (step === activeStep) {
          className = 'bg-white border-primary text-primary'
        } else if (step < activeStep) {
          className = 'bg-success border-success text-white'
          separatorClassName = 'bg-success'
        }

        return (
          <React.Fragment key={step}>
            <span
              className="d-inline-block pointer"
              onClick={() => onStepChanged(step)}
            >
              <div
                className={`StepWizard_Step position-relative border font-weight-bold font-title w-50px h-50px rounded-circle d-flex justify-content-center align-items-center ${className}`}
              >
                {step + 1}
              </div>
            </span>
            {step !== lastStep ? (
              <div
                className={`StepWizard_Separator d-inline-block w-50px align-middle ${separatorClassName}`}
              />
            ) : null}
          </React.Fragment>
        )
      })}
    </div>
  )
}

StepWizard.propTypes = {
  activeStep: PropTypes.number,
  numberOfSteps: PropTypes.number.isRequired,
  onStepChanged: PropTypes.func,
}

export default StepWizard
